import { render, staticRenderFns } from "./EpBenefitCardContainer.vue?vue&type=template&id=137000f7&"
import script from "./EpBenefitCardContainer.vue?vue&type=script&lang=js&"
export * from "./EpBenefitCardContainer.vue?vue&type=script&lang=js&"
import style0 from "./EpBenefitCardContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports